<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'teams'"
          crudName="Equipes"
          newText="Nova Equipe"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "teamsTable",
      columns: ["id", "name", "plate", "plate_model", "status", "actions"],
      options: {
        saveState: true,
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "name", "plate"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          name: "Nome",
          plate: "Placa",
          plate_model: "Modelo",
          status: "Status",
          actions: "Ações",
        },
        sortable: ["name", "plate"],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {},
        templates: {
          plate_model: function (h, row) {
            return row.plate_model === 1
              ? (<h5><span class="badge badge-info">Mercosul</span></h5>)
              : (<h5><span class="badge badge-secondary">Padrão</span></h5>);
          },
          status: function (h, row) {
            return row.status === 1
              ? (<h5><span class="badge badge-primary">Ativo</span></h5>)
              : (<h5><span class="badge badge-danger">Inativo</span></h5>);
          },
        },
        requestFunction: function (data) {
          let requestData = {};
          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [""];
          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "teams",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        name: "name",
        plate: "plate",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>
